import { Button, Flex } from 'antd'
import { useNavigate } from 'react-router-dom'
import Image from 'react-bootstrap/Image'
import ImageAi from '@/assets/img/homepage/ai.jpg'
import imageECarbon from '@/assets/img/homepage/e-carbon.jpg'
import Styles from './style.module.scss'
import ImageWrapper from '@/components/image-wrapper'

const TITLE = 'What Sets Us Apart'
const data = [
  {
    title: 'AI Energy Management',
    link: '/ai',
    image: ImageAi,
  },
  {
    title: 'E-Carbon Management',
    link: 'https://www.carusg-carbon.com',
    image: imageECarbon,
  },
]

export default function Apart() {
  const navigate = useNavigate()

  const handleClick = (link: string) => {
    if (link.startsWith('http')) {
      window.open(link, '_blank')
    } else {
      navigate(link)
    }
  }
  return (
    <div className={Styles.apart}>
      <h2>{TITLE}</h2>
      <Flex align='center' className={Styles.content}>
        {data.map(d => (
          <ImageWrapper
            key={d.title}
            mask='linear-gradient(180deg, rgba(0, 0, 0, 0.00) 53.87%, rgba(0, 0, 0, 0.60) 100%)'
            backgroundImage={d.image}
            className={Styles.item}
          >
            <h5>{d.title}</h5>
            <Button type='primary' className={Styles.button} onClick={() => handleClick(d.link)}>
              More
            </Button>
          </ImageWrapper>
        ))}
      </Flex>
    </div>
  )
}
